module.exports = __webpack_public_path__ + "img/cnn_logo.d58d0d5.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/cnn_logo.svg
// module id = ./assets/img/media/cnn_logo.svg
// module chunks = 0 9 11 12